import styled from '../../../styles/theme';
import { ModalLeadFormStyled } from '../ModalLeadFormStyled';
import { rem } from 'polished';

export const ModalLeadFormStyledAC = styled(ModalLeadFormStyled)`
    .btn-primary {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        border: none;
        border-radius: ${rem(24)};
        padding: ${rem(11)} ${rem(24)};
        background: ${({ theme }) => theme.colors.blue2};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        &:hover {
            background: ${({ theme }) => theme.colors.grey5};
        }
    }
`;
